import React from 'react';

interface DialogProps {
  title: string;
  open: boolean;
  onClose: () => void;
  children: React.ReactNode;
  footer?: React.ReactNode;
  size?: 'small' | 'medium' | 'large';
  closeOnOverlayClick?: boolean;
}

export function Dialog({
  title,
  open,
  onClose,
  children,
  footer,
  size = 'medium',
  closeOnOverlayClick = false
}: DialogProps) {
  if (!open) {
    return null;
  }

  const sizeClass = size === 'small' ? 'dialog-small' : size === 'large' ? 'dialog-large' : '';

  return (
    <div
      className="dialog-overlay"
      onClick={closeOnOverlayClick ? onClose : undefined}
    >
      <div className={`dialog ${sizeClass}`} onClick={(e) => e.stopPropagation()}>
        <div className="dialog-header">
          <h3>{title}</h3>
          <button
            type="button"
            className="ghost"
            onClick={onClose}
            aria-label="Close"
          >
            ✕
          </button>
        </div>
        <div className="dialog-content">
          {children}
        </div>
        {footer && (
          <div className="dialog-footer">
            {footer}
          </div>
        )}
      </div>
    </div>
  );
}
